import HttpWrapper from '@/utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'

const MEMBERSHIP_API = ShipbobAppSettings.membershipApi

export default class MembershipService {
  static async getOrganization (orgId) {
    const request = {
      Url: `${MEMBERSHIP_API}/API/V1/Organization/${orgId}`
    }
    return await HttpWrapper.Get(request)
      .then(response => ({ data: response, success: true }))
      .catch(error => {
        console.log(`Failed to fetch organization:  ${error.response?.data?.errors.join(',')}`)
        return { error, success: false }
      })
  }

  static async getSubaccountInvites (orgId) {
    const request = {
      Url: `${MEMBERSHIP_API}/API/V1/Subaccount/invites?organizationId=${orgId}`,
    }
    return await HttpWrapper.Get(request)
      .then(response => ({ data: response, success: true }))
      .catch(error => {
        console.log(`Failed to fetch invites:  ${error.response?.data?.errors.join(',')}`)
        return { error, success: false }
      })
  }
}

